<template>
    <div
        class="callback-popup"
        :class="device_platform"
    >
        <div class="callback-popup__inner">
            <h2 class="callback-popup__title" v-html="title"></h2>
            <a href="#" class="logo">
                <div class="logo__img"></div>
            </a>
            <a href="" class="callback-popup__phone">{{ phone }}</a>
            <callback-input
                form_class="callback-popup"
                :data="{type: 'sale', form: 'contacts'}"
            >
                Заказать
            </callback-input>
            <button
                @click.prevent="$root.$emit('callback-popup-close')"
                class="callback-popup__close-btn"></button>
        </div>
        <div
            @click="$root.$emit('callback-popup-close')"
            class="callback-popup__overlay"></div>
    </div>
</template>

<script>
import Mixin from '@/common/mixin'
import CallbackInput from '@/components/callback-form/callback-input'

export default {
    name: 'callback-popup',
    mixins: [Mixin],
    props: {
        title: String
    },
    components: {
        CallbackInput
    },
    data() {
        return {
            ...this.CONSTANTS
        }
    }
}
</script>

<style scoped lang="scss">
.logo {
    &__img {
        width: 190px;
        height: 45px;

        background-image: url("../img/logo.png");
        background-size: contain;
        background-position: 0 center;
        background-repeat: no-repeat;
    }
}

.callback-popup {
    &__inner {
        position: fixed;
        top: 50%;
        left: 50%;
        z-index: 1000;

        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 500px;
        margin: auto;
        padding: 20px;

        background-color: #fff;

        transform: translate(-50%, -50%);
    }

    &__title {
        width: 100%;
        padding: 0 20px;
        margin-bottom: 10px;

        text-align: center;
        line-height: 1.3;
    }

    &__overlay {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 990;

        width: 100vw;
        height: 100vh;

        background-color: rgba(0, 0, 0, 0.85);
    }

    &__close-btn {
        position: absolute;
        top: 20px;
        right: 20px;

        display: block;
        padding: 0;
        width: 20px;
        height: 20px;

        background: none;
        background-image: url("../img/icons/icon-close.svg");
        background-repeat: no-repeat;
        background-size: contain;
        border: none;

        cursor: pointer;
    }

    &__phone {
        display: block;
        margin-top: 10px;
        margin-bottom: 10px;

        font-size: 24px;
        font-weight: bold;
        text-decoration: none;
        color: #000;
    }
}

.mobile {
    .callback-popup {
        &__inner {
            width: 80vw;
            padding: 6vw;
        }
    }
}
</style>